import mainLogo from "../assets/logo.svg";
import mainLogoDark from "../assets/darkLogo.svg";
import { useMediaQuery, useTheme } from "@mui/material";

const Logo = ({ sm = false, forceDark = false }) => {
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));
  const largeSize = !isSmallDevice ? 450 : 280;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          margin: "0 auto",
          marginTop: sm ? 2 : isSmallDevice ? 5 : 0,
        }}
      >
        <img
          src={theme.palette.mode === "light" ? mainLogoDark : forceDark ? mainLogoDark : mainLogo}
          alt="Logo"
          style={{
            width: sm ? 110 : largeSize,
            filter:
              theme.palette.mode === "light"
                ? undefined
                : "drop-shadow(-5px -5px 10px rgb(0 0 0 / 0.3))",
          }}
        />
      </div>
    </div>
  );
};

export default Logo;
